import EStyleSheet from "react-native-extended-stylesheet";

export const styles = EStyleSheet.create({
  background: {
    backgroundColor: "$background",
  },
  card: {
    paddingHorizontal: 0,
    backgroundColor: "$home_card",
  },
  layout: {
    flex: 1,
    justifyContent: "center",
  },
  logoContainer: {
    justifyContent: "center",
    alignItems: "center",
    marginTop: "3vh",
  },
  descriptionContainer: {
    flex: 1,
    alignItems: "center",
    alignSelf: "center",
  },
  description: {
    paddingHorizontal: "6vw",
    marginVertical: "5vh",
    textAlign: "center",
    color: "$home_text",
    fontSize: "$home_text_size",
    fontFamily: "$home_text_style",
  },
  logo: {
    width: "$width_logo",
    height: "$height_logo",
  },
  button: {
    color: "$home_button",
  },
  footer: {
    marginTop: 30,
  },
  iconContainer: {
    flex: 1,
  },
  icon: {
    color: "$home_info_text",
    fontSize: "$home_info_icon_size",
    fontFamily: "$home_info_icon_style",
  },
  policy: {
    marginVertical: 10,
    textAlign: "center",
    color: "$home_info_text",
    fontSize: "$home_info_text_size",
    fontFamily: "$home_info_text_style",
  },
  takerDetail: {
    alignItems: "center",
  },
  takerDetailText: {
    color: "$home_info_text",
    fontSize: "$home_info_text_size",
    fontFamily: "$home_info_text_style",
  },
  appVersion: {
    textAlign: "right",
    color: "$home_info_text",
    fontSize: "$home_info_text_size",
    fontFamily: "$home_info_text_style",
  },
  appInfo: {
    paddingHorizontal: 10,
    paddingBottom: 10,
    flexDirection: "row",
  },
  error: {
    alignItems: "center",
  },
  errorMessage: {
    marginVertical: 10,
    textAlign: "center",
    color: "$home_info_text",
    fontSize: "$home_info_text_size",
    fontFamily: "$home_info_text_style",
  },
});
